import { render, staticRenderFns } from "./AprovarReprovarReagendarFormacao.vue?vue&type=template&id=882882b6"
import script from "./AprovarReprovarReagendarFormacao.vue?vue&type=script&lang=js"
export * from "./AprovarReprovarReagendarFormacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports